export const RQ_REGISTER_TENANT_API = {
  url: 'api/v1/tenant/register',
  method: 'POST',
  auth: true,
};

export const RQ_GET_ALL_TENANT_LIST_PAGEABLE_API = {
  url: 'api/v1/tenant/pageable/lookup/all?page=<%= pageParam %>&',
  method: 'GET',
  auth: true,
  search: true,
};

export const RQ_GET_ALL_TENANT_API = {
  url: 'api/v1/tenant/lookup/alltenants/search/all',
  method: 'GET',
  auth: true,
  search: true,
};

export const RQ_PUT_UPDATE_TENANT_API = {
  url: 'api/v1/tenant/<%= id %>/update/allfields',
  method: 'PUT',
  auth: true,
  search:true,
};

export const RQ_PUT_UPDATE_TENANT_STATUS_API = {
  url: 'api/v1/tenant/<%= id %>/update/status',
  method: 'PUT',
  auth: true,
  search:true,
};
